import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import { createApp } from 'vue';

import App from './App.vue';
import router from './router';

const app = createApp(App);
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
app.use(pinia);

app.use(router);

const entryNode = document.querySelector('#get-a-mortgage');

if (!entryNode) {
	throw new Error('Missing \'get-a-mortgage\' entry node');
}

app.mount(entryNode);
